class Settings extends HTMLElement
{
	#host;

	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	get geminiApiKey() { return this.shadowRoot.querySelector("#geminiApiKey").value; };
	set geminiApiKey(v) { this.shadowRoot.querySelector("#geminiApiKey").value = v; };

	get openaiApiKey() { return this.shadowRoot.querySelector("#openaiApiKey").value };
	set openaiApiKey(v) { this.shadowRoot.querySelector("#openaiApiKey").value = v; };

	get ollamaUrl() { return this.shadowRoot.querySelector("#ollamaUrl").value; };
	set ollamaUrl(v) { this.shadowRoot.querySelector("#ollamaUrl").value = v; };

	get qdrantUrl() { return this.shadowRoot.querySelector("#qdrantUrl").value; };
	set qdrantUrl(v) { this.shadowRoot.querySelector("#qdrantUrl").value = v; };

	get server() {
		return this.shadowRoot.querySelector('input[name="server"]:checked')?.value;
	};
	set server(v) {
		const elem = this.shadowRoot.querySelector(`input[name="server"][value="${v}"]`);
		if (elem) elem.checked = true;

		this.shadowRoot.querySelectorAll('input[name="server"]').forEach(el => {
			el.dispatchEvent(new Event("change"));
		});
	};

	get model() {
		return this.shadowRoot.querySelector(`#${this.server}Model`)?.value;
	};
	set model(v) {
		const elem = this.shadowRoot.querySelector(`#${this.server}Model`);
		if (elem) {
			elem.value = v;
			elem.dispatchEvent(new Event("change"));
		}

		/**
		this.dispatchEvent(new CustomEvent("setting-change", {
			detail: { server: this.server, model: this.model }
		})); */
	};
	
	connectedCallback() {

		this.#host = this.getRootNode().host;

		const customImport = nine.cssPath ? `@import "${nine.cssPath}/nine-ai.css";` : "";

		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/@ninebone/ai@${__APP_VERSION__}/dist/css/nine-ai.css";
				${customImport}
			</style>

			<div class="line subject">
				<label for="server">Server:</label>
			</div>
			<div class="line contents">
				<!--<label><input name="server" type="radio" value="chatopenai" >Chat Open AI</label>-->
				<label><input name="server" type="radio" value="gemini" checked>Gemini</label>
				<label><input name="server" type="radio" value="openai">Open AI</label>
				<label><input name="server" type="radio" value="ollama">Ollama</label>
			</div>
			<div class="line gemini-bak" style="display:none;">
				<label>API Key: <input id="geminiApiKey" value=""/></label>
			</div>
			<div class="line openai-bak" style="display:none;">
				<label>API Key: <input id="openaiApiKey" value=""/></label>
			</div>
			<div class="line subject ollama">
				<label for="ollamaUrl">Server Url:</label>
			</div>
			<div class="line contents ollama">
				<input type="text" id="ollamaUrl" value="http://localhost:11434"/></label>
			</div>
			<div class="line subject ollama">
				<label for="ollamaModel">Model:</label>
			</div>
			<div class="line contents ollama">
				<select id="ollamaModel">
					<option value="codellama:13b">codellama:13b</option>
					<option value="deepseek-coder:6.7b">deepseek-coder:6.7b</option>
					<option value="phi4:14b">phi4:14b</option>
					<option value="llama3.1:8b">llama3.1:8b</option>
					<option value="mistral:7b">mistral:7b</option>
				</select>
			</div>
			<div class="line subject gemini">
				<label for="geminiModel">Model:</label>
			</div>
			<div class="line contents gemini">
				<select id="geminiModel">
					<option value="gemini-2.5-flash">gemini-2.5-flash</option>
					<option value="gemini-2.5-pro">gemini-2.5-pro</option>
					<option value="gemini-2.0-flash-exp">gemini-2.0-flash-exp</option>
       				<option value="gemini-2.0-flash-latest">gemini-2.0-flash-latest</option>
				</select>
			</div>
			<div class="line subject chatopenai">
				<label for="chatopenaiModel">Model:</label>
			</div>
			<div class="line contents chatopenai">
				<select id="chatopenaiModel">
					<option value="google/gemma-2-9b-it">google/gemma-2-9b-it</option>
				</select>
			</div>
			<div class="line subject openai">
				<label for="openaiModel">Model:</label>
			</div>
			<div class="line contents openai">
				<select id="openaiModel">
					<option value="gpt-4">gpt-4</option>
					<option value="gpt-4o">gpt-4o</option>
					<option value="gpt-3.5-turbo">gpt-3.5-turbo</option>
				</select>
			</div>
			
			<div class="line subject qdrant">
				<label for="qdrantUrl">Qdrant Url:</label>
			</div>
			<div class="line contents qdrant">
				<input type="text" id="qdrantUrl" value="http://localhost:6333"/>
			</div>

			<div class="line subject analyze">
				<input id="chkAnalyze" type="checkbox" checked> <input id="txtAnalyze" type="number" value="100"><label>건 미만인 경우 데이타 분석 요청</label>
			</div>
		`;

		this.#init();

		setTimeout(() => {
        	this.server = "chatopenai";
    	}, 0);
	};

	

	#init = () => {

		this.shadowRoot.querySelectorAll('input[name="server"]').forEach((radio) => {
			radio.addEventListener("change", () => {
				const server = this.shadowRoot.querySelector('input[name="server"]:checked').value;

				["gemini","openai","ollama","chatopenai"].forEach(v => {
					this.shadowRoot.querySelectorAll('.' + v).forEach((elem) => {
						elem.style.display = (server === v) ? "flex" : "none";
					});
				});
			});
		});
	}
}

if (!customElements.get("nine-ai-settings")) {
	customElements.define("nine-ai-settings", Settings);
}
